import qs from 'qs'

import { ConversationsListStatus } from '@app/hooks'
import { communicationsApi } from '@app/services'

import { isB2BView } from '@app/utils'

import { FetchUnreadListRespoonce, UnreadSummary } from './types'

export const fetchUnreadList = async (
  status: ConversationsListStatus[]
): Promise<UnreadSummary> => {
  try {
    const response = await communicationsApi.get<FetchUnreadListRespoonce>(
      'conversation/unread',
      {
        params: {
          status: (isB2BView() && status) || undefined,
        },
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: 'repeat' }),
      }
    )
    const unreadArray = Object.keys(response?.data?.conversations ?? {}).map(
      (conversation) => Number(conversation)
    )
    return {
      unreadList: unreadArray || [],
      total: response?.data?.total ?? unreadArray.length,
    }
  } catch (error) {
    console.log(error)
    return {
      unreadList: [],
      total: 0,
    }
  }
}
